import { Checkbox, getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import OnOffSwitch from 'src/components/OnOffSwitch/OnOffSwitch'
import Trns from 'src/localization/Trns'
import { TransactionReceiptStatus } from 'src/models/transaction.models'
import { selectBrandColorCta } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface TransactionReceiptStatusFilterProps {
  receiptStatusSet: Set<string>
  handleReceiptStatusSelection: (status: string) => Set<string>
  receiptRequired: boolean | undefined
  setReceiptRequired: (required: boolean) => void
}

const TransactionReceiptStatusFilter: React.FC<TransactionReceiptStatusFilterProps> = ({
  receiptStatusSet,
  handleReceiptStatusSelection,
  receiptRequired,
  setReceiptRequired,
}) => {
  const brandColorCta = useSelector(selectBrandColorCta)

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Receipt Status'} />
      </div>
      <Checkbox
        label={<Trns source={'Attached'} />}
        onClick={(): void => {
          handleReceiptStatusSelection(
            TransactionReceiptStatus.Attached,
          )
        }}
        isSelected={receiptStatusSet.has(
          TransactionReceiptStatus.Attached,
        )}
      />
      <Checkbox
        label={<Trns source={'Missing'} />}
        onClick={(): void => {
          handleReceiptStatusSelection(
            TransactionReceiptStatus.Missing,
          )
        }}
        isSelected={receiptStatusSet.has(
          TransactionReceiptStatus.Missing,
        )}
      />
      <div
        css={css`
          margin-top: 20px;
          display: flex;
          align-items: flex-start;
          gap: 8px;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <Trns
            source={'Only show transactions that require receipts'}
          />
        </span>
        <OnOffSwitch
          onBgColor={brandColorCta}
          smallMode
          defaultOnOffState={receiptRequired}
          onChange={(val: boolean): void => {
            setReceiptRequired(val)
          }}
        />
      </div>
    </div>
  )
}

export default TransactionReceiptStatusFilter
